import React, { useEffect, useState } from "react";
import { getAnalytics } from "../../api/adminApi";
import { SkeletonCard } from "../common/SkeletonBlock";

export default function AdminAnalyticsCards() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    try {
      setLoading(true);
      const res = await getAnalytics();
      setData(res.data);
    } catch (e) {
      console.error("Failed to load analytics", e);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="grid-analytics">
        <SkeletonCard lines={2} titleWidth="55%" />
        <SkeletonCard lines={2} titleWidth="45%" />
        <SkeletonCard lines={2} titleWidth="50%" />
        <SkeletonCard lines={2} titleWidth="40%" />
        <SkeletonCard lines={2} titleWidth="46%" />
        <SkeletonCard lines={2} titleWidth="58%" />
      </div>
    );
  }

  if (!data) return null;

  return (
    <div className="grid-analytics">
      <div className="analytics-card">
        <div className="analytics-label">Total Documents</div>
        <div className="analytics-value">{data.totalDocuments}</div>
      </div>

      <div className="analytics-card">
        <div className="analytics-label">Active</div>
        <div className="analytics-value">{data.activeDocuments}</div>
      </div>

      <div className="analytics-card">
        <div className="analytics-label">Completed</div>
        <div className="analytics-value">{data.completedDocuments}</div>
      </div>

      <div className="analytics-card">
        <div className="analytics-label">Expired</div>
        <div className="analytics-value">{data.expiredDocuments}</div>
      </div>

      <div className="analytics-card">
        <div className="analytics-label">Total Signers</div>
        <div className="analytics-value">{data.totalSigners}</div>
      </div>

      <div className="analytics-card">
        <div className="analytics-label">Avg Views Before Sign</div>
        <div className="analytics-value">
          {Number(data.avgViewsBeforeSign || 0).toFixed(1)}
        </div>
      </div>
    </div>
  );
}